<script setup lang="ts">
const props = defineProps({
    items: {
        type: Number,
        default: 1,
        required: true
    }
})
const animation = ref('pulse')
</script>

<template>
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-2 tw-divide-y tw-divide-home-deli-gray tw-divide-2 tw-px-2 tw-mb-2"
        v-for="item in items" :key="item">
        <div class="tw-grid tw-grid-cols-6 tw-w-full tw-gap-2 tw-items-center">
            <q-skeleton width="40px" height="40px" :animation="animation" />
            <div class="tw-col-span-5 tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-2 tw-pr-2">
                <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-mt-1">
                    <q-skeleton height="30px" :animation="animation" />
                    <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full ">
                        <q-skeleton width="40px" :animation="animation" />
                        <q-skeleton width="40px" :animation="animation" />
                        <q-skeleton width="40px" :animation="animation" />
                    </div>
                </div>
                <q-skeleton size="30px" :animation="animation" />
            </div>

        </div>
    </div>
</template>